/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFabFamilyInformation } from './field-fab-family-information.component';
import { SysquePropertiesListModule } from '../../../../../../../shared/ui/src/lib/components/sysque-properties-list';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueDropdownServiceTypeModule } from '../../../../../../../shared/ui/src/lib/components/sysque-dropdown-service-type';
import { SysqueDropdownConnectorsModule } from '../../../../../../../shared/ui/src/lib/components/sysque-dropdown-connectors';
import { SysqueToggleButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-switch-button';
import { SysqueTextBoxDescriptionModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-area-description';
import { SysqueDatagridSizeRangeModule } from '../../../../../../../shared/ui/src/lib/components/sysque-datagrid-size-range';
import { SysquePdfLocationModule } from '../../../../../../../shared/ui/src/lib/components/sysque-pdf-location';
import { DxButtonModule, DxTabPanelModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { LineGraphicsModule } from '../line-graphics';
import { SysqueContextMenuModule } from '../../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { CreateServiceTypeModule } from '../create-service-type';
import { DeleteServiceTypeModule } from '../delete-service-type';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/field-fab-family-information-dialog', component: FieldFabFamilyInformation }];

@NgModule({
  declarations: [FieldFabFamilyInformation],
  imports: [
    CommonModule, 
    SysquePropertiesListModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueDropdownServiceTypeModule,
    SysqueDropdownConnectorsModule,
    SysqueToggleButtonModule,
    SysqueTextBoxDescriptionModule,
    SysqueDatagridSizeRangeModule,
    SysquePdfLocationModule,
    DxButtonModule, 
    DxTabPanelModule,
    AlertModule,
    LineGraphicsModule,
    CreateServiceTypeModule,
    DeleteServiceTypeModule,
    SysqueContextMenuModule,
    RouterModule.forChild(routes)
  ],
  exports: [FieldFabFamilyInformation],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FieldFabFamilyInformationModule {}
